import { apiClient } from '~/api/client';

type SearchParams = {
  query: string;
  page: number;
  per_page: number;
  sort_field?: string;
  sort_order?: string;
};

export const search = async (params: SearchParams) =>
  apiClient.get('/support/companies', { params });

type UpdateFeatureFlagParams = {
  companyId: string;
  name: string;
  enabled: boolean;
};

type UpdateFeatureFlagResponse = {
  feature_flags: string[];
};

export const updateFeatureFlag = async (params: UpdateFeatureFlagParams) =>
  apiClient.patch<UpdateFeatureFlagResponse>(
    `/support/companies/${params.companyId}/feature_flag`,
    { name: params.name, enabled: params.enabled }
  );
